/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    LDAPServerReference,
    LDAPServerReferenceFromJSON,
    LDAPServerReferenceFromJSONTyped,
    LDAPServerReferenceToJSON,
} from './';

/**
 * 
 * @export
 * @interface ElementsUserDetail
 */
export interface ElementsUserDetail {
    /**
     * 
     * @type {number}
     * @memberof ElementsUserDetail
     */
    id: number;
    /**
     * 
     * @type {boolean}
     * @memberof ElementsUserDetail
     */
    allowChangingPassword?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ElementsUserDetail
     */
    allowWanLogin?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ElementsUserDetail
     */
    readonly allowedFsPaths: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ElementsUserDetail
     */
    readonly allowedFsWritePaths: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof ElementsUserDetail
     */
    avatar?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ElementsUserDetail
     */
    defaultPage?: string;
    /**
     * 
     * @type {string}
     * @memberof ElementsUserDetail
     */
    readonly displayName: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ElementsUserDetail
     */
    readonly effectivePermissions: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ElementsUserDetail
     */
    email?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ElementsUserDetail
     */
    expiry?: Date | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ElementsUserDetail
     */
    fmBookmarks?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ElementsUserDetail
     */
    fullName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ElementsUserDetail
     */
    gid?: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ElementsUserDetail
     */
    readonly groupPermissions: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof ElementsUserDetail
     */
    readonly hasPassword: boolean;
    /**
     * 
     * @type {number}
     * @memberof ElementsUserDetail
     */
    home?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof ElementsUserDetail
     */
    isExternal?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ElementsUserDetail
     */
    isCloud?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ElementsUserDetail
     */
    isCloudDefault?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ElementsUserDetail
     */
    isEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ElementsUserDetail
     */
    language?: ElementsUserDetailLanguageEnum;
    /**
     * 
     * @type {Date}
     * @memberof ElementsUserDetail
     */
    lastSeen?: Date | null;
    /**
     * 
     * @type {LDAPServerReference}
     * @memberof ElementsUserDetail
     */
    ldap?: LDAPServerReference;
    /**
     * 
     * @type {string}
     * @memberof ElementsUserDetail
     */
    ldapDn?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ElementsUserDetail
     */
    passwordChangeRequired?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ElementsUserDetail
     */
    permissions: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof ElementsUserDetail
     */
    shaperCeiling?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ElementsUserDetail
     */
    shaperRate?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ElementsUserDetail
     */
    readonly syncId: string;
    /**
     * 
     * @type {boolean}
     * @memberof ElementsUserDetail
     */
    totpEnabled?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ElementsUserDetail
     */
    uid?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ElementsUserDetail
     */
    unixUsername?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ElementsUserDetail
     */
    username: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof ElementsUserDetail
     */
    groups: Array<number>;
}

/**
* @export
* @enum {string}
*/
export enum ElementsUserDetailLanguageEnum {
    En = 'en',
    Fr = 'fr',
    De = 'de',
    Ru = 'ru'
}

export function ElementsUserDetailFromJSON(json: any): ElementsUserDetail {
    return ElementsUserDetailFromJSONTyped(json, false);
}

export function ElementsUserDetailFromJSONTyped(json: any, ignoreDiscriminator: boolean): ElementsUserDetail {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'allowChangingPassword': !exists(json, 'allow_changing_password') ? undefined : json['allow_changing_password'],
        'allowWanLogin': !exists(json, 'allow_wan_login') ? undefined : json['allow_wan_login'],
        'allowedFsPaths': json['allowed_fs_paths'],
        'allowedFsWritePaths': json['allowed_fs_write_paths'],
        'avatar': !exists(json, 'avatar') ? undefined : json['avatar'],
        'defaultPage': !exists(json, 'default_page') ? undefined : json['default_page'],
        'displayName': json['display_name'],
        'effectivePermissions': json['effective_permissions'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'expiry': !exists(json, 'expiry') ? undefined : (json['expiry'] === null ? null : new Date(json['expiry'])),
        'fmBookmarks': !exists(json, 'fm_bookmarks') ? undefined : json['fm_bookmarks'],
        'fullName': !exists(json, 'full_name') ? undefined : json['full_name'],
        'gid': !exists(json, 'gid') ? undefined : json['gid'],
        'groupPermissions': json['group_permissions'],
        'hasPassword': json['has_password'],
        'home': !exists(json, 'home') ? undefined : json['home'],
        'isExternal': !exists(json, 'is_external') ? undefined : json['is_external'],
        'isCloud': !exists(json, 'is_cloud') ? undefined : json['is_cloud'],
        'isCloudDefault': !exists(json, 'is_cloud_default') ? undefined : json['is_cloud_default'],
        'isEnabled': !exists(json, 'is_enabled') ? undefined : json['is_enabled'],
        'language': !exists(json, 'language') ? undefined : json['language'],
        'lastSeen': !exists(json, 'last_seen') ? undefined : (json['last_seen'] === null ? null : new Date(json['last_seen'])),
        'ldap': !exists(json, 'ldap') ? undefined : LDAPServerReferenceFromJSON(json['ldap']),
        'ldapDn': !exists(json, 'ldap_dn') ? undefined : json['ldap_dn'],
        'passwordChangeRequired': !exists(json, 'password_change_required') ? undefined : json['password_change_required'],
        'permissions': json['permissions'],
        'shaperCeiling': !exists(json, 'shaper_ceiling') ? undefined : json['shaper_ceiling'],
        'shaperRate': !exists(json, 'shaper_rate') ? undefined : json['shaper_rate'],
        'syncId': json['sync_id'],
        'totpEnabled': !exists(json, 'totp_enabled') ? undefined : json['totp_enabled'],
        'uid': !exists(json, 'uid') ? undefined : json['uid'],
        'unixUsername': !exists(json, 'unix_username') ? undefined : json['unix_username'],
        'username': json['username'],
        'groups': json['groups'],
    };
}

export function ElementsUserDetailToJSON(value?: ElementsUserDetail | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'allow_changing_password': value.allowChangingPassword,
        'allow_wan_login': value.allowWanLogin,
        'avatar': value.avatar,
        'default_page': value.defaultPage,
        'email': value.email,
        'expiry': value.expiry === undefined ? undefined : (value.expiry === null ? null : value.expiry.toISOString()),
        'fm_bookmarks': value.fmBookmarks,
        'full_name': value.fullName,
        'gid': value.gid,
        'home': value.home,
        'is_external': value.isExternal,
        'is_cloud': value.isCloud,
        'is_cloud_default': value.isCloudDefault,
        'is_enabled': value.isEnabled,
        'language': value.language,
        'last_seen': value.lastSeen === undefined ? undefined : (value.lastSeen === null ? null : value.lastSeen.toISOString()),
        'ldap': LDAPServerReferenceToJSON(value.ldap),
        'ldap_dn': value.ldapDn,
        'password_change_required': value.passwordChangeRequired,
        'permissions': value.permissions,
        'shaper_ceiling': value.shaperCeiling,
        'shaper_rate': value.shaperRate,
        'totp_enabled': value.totpEnabled,
        'uid': value.uid,
        'unix_username': value.unixUsername,
        'username': value.username,
        'groups': value.groups,
    };
}


